import type {createAppRouter} from "@project/router";

import {RouterProvider} from "@tanstack/react-router";

interface TanStackRouterProviderProps {
  children?: React.ReactNode;
  router: ReturnType<typeof createAppRouter>;
}

/**
 * Root provider for TanStack Router.
 *
 * DevTools: Handled by AppDevtools in DevToolsProvider (unified shell).
 * Do NOT add Router Devtools here — it would duplicate the Router panel.
 *
 * @see DevToolsProvider — Single unified devtools entry point
 */
export default function TanStackRouterProvider({children, router}: TanStackRouterProviderProps) {
  return (
    <>
      <RouterProvider router={router} />
      {children}
    </>
  );
}
